export default "__VITE_ASSET__B_E1F5pr__";